export function isEmpty(obj = {}) {
	return Object.keys(obj).length === 0;
}

export function isString(value) {
	return typeof value === 'string' || value instanceof String;
}

export function isNumber(value) {
	return typeof value == 'number' && !isNaN(value);
}

export function isBoolean(value) {
	return value === true || value === false;
}

export function isNil(value) {
	return typeof value === 'undefined' || value === null;
}

export function isDateString(value) {
	if (!isString(value)) return false;

	return value.match(/^\d{2}-\d{2}-\d{4}$/);
}

export function convertDateString(value) {
	return value.substr(6, 4) + value.substr(3, 2) + value.substr(0, 2);
}

export function toLower(value) {
	if (isString(value)) {
		return value.toLowerCase();
	}
	return value;
}

export function convertType(value) {
	if (isNumber(value)) {
		return value.toString();
	}

	if (isDateString(value)) {
		return convertDateString(value);
	}

	if (isBoolean(value)) {
		return value ? '1' : '-1';
	}

	return value;
}

export function filterRows(rows, filters) {
	if (isEmpty(filters)) return rows;

	return rows.filter(row => {
		return Object.keys(filters).every(accessor => {
			const value = row[accessor];
			const searchValue = filters[accessor];

			if (isString(value)) {
				return toLower(value).includes(toLower(searchValue));
			}

			if (isBoolean(value)) {
				return (searchValue === 'true' && value) || (searchValue === 'false' && !value);
			}

			if (isNumber(value)) {
				return value === searchValue;
			}

			return false;
		});
	});
}

export function sortRows(rows, sort) {
	return rows.sort((a, b) => {
		const { order, orderBy } = sort;

		if (isNil(a[orderBy])) return 1;
		if (isNil(b[orderBy])) return -1;

		const aLocale = convertType(a[orderBy]);
		const bLocale = convertType(b[orderBy]);

		if (order === 'asc') {
			return aLocale.localeCompare(bLocale, 'en', { numeric: isNumber(b[orderBy]) });
		} else {
			return bLocale.localeCompare(aLocale, 'en', { numeric: isNumber(a[orderBy]) });
		}
	});
}

export function paginateRows(sortedRows, activePage, rowsPerPage) {
	return [...sortedRows].slice((activePage - 1) * rowsPerPage, activePage * rowsPerPage);
}

export const formatTooltipTitle = tooltipTitle => {
	const label = tooltipTitle[0].label.replace(', 12:00:00 a.m.', '');
	const time = tooltipTitle[0].formattedValue
		.toString()
		.replace(/,/g, '')
		.replace(/(.{2})$/, ':$1')
		.padStart(5, '0');
	return `${label}: ${time}`;
};

export const formatTooltipLabel = () => {
	return;
};

export const formatTime = time => {
	const parts = time
		.toString()
		.replace(/(.{2})$/, ':$1')
		.padStart(5, '0');
	return parts;
};

export const getCurrentTime = () => {
	let currentDate = new Date();
	let currentHour = currentDate.getHours();
	currentHour = ('0' + currentHour).slice(-2);
	let currentMinutes = currentDate.getMinutes();
	return `${currentHour}:${currentMinutes}`;
};

export const airQualityStatus = value => {
	if (value <= 15) {
		return 'good';
	} else if (15 >= value || value <= 30) {
		return 'fair';
	} else if (31 >= value || value <= 55) {
		return 'moderate';
	} else if (56 >= value || value <= 110) {
		return 'unhealthy';
	} else if (value >= 100) {
		return 'dangerous';
	}
};

export const windQualityStatus = value => {
	if (value <= 2) {
		return 'calm';
	} else if (3 >= value || value <= 12) {
		return 'light';
	} else if (13 >= value || value <= 30) {
		return 'moderate';
	} else if (31 >= value || value <= 50) {
		return 'fresh';
	} else if (51 >= value || value <= 62) {
		return 'strong';
	} else if (63 >= value || value <= 87) {
		return 'gale';
	} else if (88 >= value || value <= 117) {
		return 'storm';
	} else if (value >= 118) {
		return 'hurricane';
	}
};

export const humidityStatus = value => {
	if (value <= 55) {
		return 'pleasant';
	} else if (56 >= value || value <= 60) {
		return 'comfortable';
	} else if (61 >= value || value <= 64) {
		return 'sticky';
	} else if (65 >= value || value <= 70) {
		return 'uncomfortable';
	} else if (value >= 71) {
		return 'oppressive';
	}
};

export const temperatureStatus = value => {
	if (value <= 7) {
		return 'freezing';
	} else if (8 >= value || value <= 12) {
		return 'cold';
	} else if (13 >= value || value <= 17) {
		return 'cool';
	} else if (18 >= value || value <= 22) {
		return 'mild';
	} else if (23 >= value || value <= 27) {
		return 'warm';
	} else if (28 >= value || value <= 32) {
		return 'hot';
	} else if (value >= 33) {
		return 'extreme';
	}
};

export const generateRandomIconNumber = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1) + min);
};
